import { IsString, MaxLength, IsNotEmpty, IsInt, IsOptional, IsUUID } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class AddressEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    address: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    city: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(25)
    zip: string;

    @IsNotEmpty()
    @IsInt()
    country: number;

    @IsOptional()
    @IsString()
    note: string;

    @IsNotEmpty()
    @IsInt()
    type: number;

    @IsNotEmpty()
    @IsUUID()
    account: string;

}
